import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'
import { useChatUnreadCount } from '#/widgets/phone-panel'

import { customerNumbers } from '../lib/customer-numbers'

/** Unread SMS count across the shipment customer's numbers, for the chat tab
 *  badge. Scoped to the shipment's owning agent when one is set. */
export function useShipmentChatUnread(
  shipment: ShipmentDetail | undefined,
): number {
  return useChatUnreadCount(
    customerNumbers(shipment?.customer).map((option) => option.value),
    shipment?.user?.id,
  )
}
